<template>
  <v-card>
    <v-card-text>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline">Negociações</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <div class="text--primary">
        <px-acompanhamentos allow-files
                            :disabled="!isAberta"
                            :item-type="messageType"
                            :item-id="resposta.id"
                            :user="user"
                            @on-message="onMessage"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import { mapGetters } from 'vuex';
import RespostaFreteService from '../../resposta-frete-service';

const ABERTAS = [SituacaoCotacao.keys.ABERTA.key,
  SituacaoCotacao.keys.CARRINHO.key,
  SituacaoCotacao.keys.COMPRA.key];

export default {
  props: {
    resposta: Object,
    cotacao: Object,
  },
  data() {
    return {
      messageType: this.$px.types.NEGOCIACAO_COTACAO_FRETE,
    };
  },
  computed: {
    isAberta() {
      return ABERTAS.includes(this.cotacao.situacao);
    },
    ...mapGetters('user', ['user']),
  },
  methods: {
    onMessage() {
      RespostaFreteService.notificarNegociacao(this.resposta.id);
    },
  },
};
</script>
